import axios from 'axios'
import { Message } from 'element-ui'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API // api 的 base_url
})

// request interceptor
service.interceptors.request.use(

  config => {
    const urlInfo = JSON.parse(sessionStorage.getItem('urlInfo'))
    config.headers.Authorization = `Bearer ${urlInfo.token}`
    config.responseType = 'blob' // 导出blob流 设置
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
